export default "__VITE_ASSET__BTWkFoPB__"